import { useEffect } from "react";

function BooleansResponse({action, booleans, setBooleans}) {
  useEffect(() => {
    const newBoolean={}
    const arrayBooleans = action.booleans?.split("\n").filter(element => element)||[];
    const uniqueBooleans = [...new Set(arrayBooleans)];
    uniqueBooleans.forEach ((bool)=> {
      if(booleans && booleans[bool]){
        newBoolean[bool] = booleans[bool]
      }else{
        newBoolean[bool] = false
      }
     
    })
    setBooleans(newBoolean)
  }, [])
  
const changeBoolean = (key)=>{
  const duplicate = {...booleans}
  duplicate[key] = !duplicate[key]
  setBooleans(duplicate)
}
    
  return (
    <>
{booleans && Object.keys(booleans).map((key,i)=>{
  return (

    <label key={`boolean-active-${i}`} className="form__label form__checkbox-container" htmlFor={`boolean-active-${i}`}>
   
     <input
         className="form__checkbox"
         id={`boolean-active-${i}`}
         name="active"
         type="checkbox"
         checked={booleans[key]}
         onChange={(e)=>changeBoolean(key, e.target.value)}
     /> {key}
 </label>
  )
})}
    </>
   
  )
}

export default BooleansResponse